import { render, staticRenderFns } from "./addBanner.vue?vue&type=template&id=3faa473c&scoped=true&"
import script from "./addBanner.vue?vue&type=script&lang=js&"
export * from "./addBanner.vue?vue&type=script&lang=js&"
import style0 from "./addBanner.vue?vue&type=style&index=0&id=3faa473c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faa473c",
  null
  
)

export default component.exports